import * as React from "react";

import { cn } from "../lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Forms design language (library spec; tokens in @eaco/forms-core).
          // Sized in px because this app's root font-size is 10px, so rem
          // utilities render ~0.6x. 14px text, 11/13 padding, 1px border,
          // 10px radius; filled fields get the light bg, focus the accent ring.
          "flex w-full rounded-[var(--forms-input-radius)] border-[length:var(--forms-input-border-w)] border-[var(--forms-border)] bg-white px-[var(--forms-input-px)] py-[var(--forms-input-py)] text-[length:var(--forms-input-font)] leading-[1.2] text-[var(--forms-ink)] transition-[border-color,box-shadow,background-color] file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[var(--forms-faint)] [&[placeholder]:not(:placeholder-shown):not(:focus)]:border-[var(--forms-input-filled-border)] [&[placeholder]:not(:placeholder-shown):not(:focus)]:bg-[var(--forms-input-filled-bg)] focus-visible:border-[var(--forms-accent,var(--forms-accent-default))] focus-visible:shadow-[0_0_0_3px_var(--forms-accent-ring,var(--forms-accent-ring-default))] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
